import { RawCompanyData } from '@company/const';
import { Action } from '@ngrx/store';

export const SYNC_SAVED_COMPANY_STATE = '[Company] Sync Saved Company State';
export const SAVE_UNADDED_COMPANY = '[Company] Save Unadded Company';
export const RESET_SAVED_COMPANY = '[Company] Reset Saved Company';

export class SyncSavedCompanyState implements Action {
  readonly type = SYNC_SAVED_COMPANY_STATE;

  constructor(public payload: RawCompanyData) {}
}

export class SaveUnaddedCompany implements Action {
  readonly type = SAVE_UNADDED_COMPANY;

  constructor(public payload: RawCompanyData) {}
}

export class ResetSavedCompany implements Action {
  readonly type = RESET_SAVED_COMPANY;
}

export type SaveUnaddedCompanyActions = SaveUnaddedCompany | SyncSavedCompanyState | ResetSavedCompany;
